<template>
  <v-sheet class="mb-3">
    <v-layout row wrap>
        <v-flex xs12>
          <h5>Registration For:</h5>
        </v-flex>
        <v-flex xs12 pa-2>
            <div class="display-1">{{ registration.fname }} {{ registration.mname }} {{ registration.lname }}</div>
        </v-flex>
        <v-flex xs12>
          <v-divider />
        </v-flex>
    </v-layout>
  </v-sheet>
</template>

<script>
export default {
  name: 'RegistrationDetail',
  props: {
      registration: Object
  }
}
</script>

<style scoped>

</style>